import { Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import Separator from 'shared/layout/Separator';
import Spacer from 'shared/layout/Spacer';
import Question from './Question';

export default observer(({ form }) => {
  const {
    questions: { sections = [] },
  } = form;

  return sections.map((s, idx) => (
    <Fragment key={idx}>
      <Spacer top={30} bottom={30}>
        <Separator />
      </Spacer>
      {s.questions
        .filter((question) => !question.hidden)
        .map((question, index) => (
          <Question question={question} key={question.id} disabled={form.disabled} />
        ))}
    </Fragment>
  ));
});
